import { stringify } from 'sh-api-client/src/SearchParams/SearchParams.js';

const angularToReactMap = {
	categories: { name: 'categoryNames', type: 'array', separator: ';' },
	classifications: { name: 'classificationNames', type: 'array', separator: ';' },
	tags: { name: 'tags', type: 'array', separator: ',' },
	domains: { name: 'domainNames', type: 'array', separator: ',' },
	publishers: { name: 'publisher', type: 'array', separator: ',' },
	wasEmailed: { name: 'wasEmailed', type: 'bool' },
	inStory: { name: 'inStory', type: 'bool' },
	myFavorites: { name: 'myFavorites', type: 'bool' },
	term: { name: 'term', type: 'string' },
	multihub: { name: 'hubIds', type: 'string', valueMapping: { mine: 'account' } },
	datePreset: { name: 'datePreset', type: 'string' },
	dateStart: { name: 'sinceDate', type: 'dateString' },
	dateEnd: { name: 'beforeDate', type: 'dateString' },
	archiveAction: { name: 'archiveAction', type: 'string' },
	archiveDatePreset: { name: 'archiveDatePreset', type: 'string' },
};

/**
 * Map url params from angular finetune object to react
 */
export class UrlParamsMapper {
	/**
	 * Map classic (angular insights page) search params to the new (react /core/insights) search params
	 * takes in an object gotten from calling  UrlData.get('finetune') and map it to the react insight page url search params.
	 * @param {Object} finetune  An object from calling UrlData.get('finetune')
	 * @return {String} the query string to append to core/inisghts doesn't include the ?
	 */
	static mapAngularSearchObjToReactQueryParams(finetune) {
		const reactSearchObj = {};
		if (finetune) {
			for (const property in finetune) {
				if (angularToReactMap[property]) {
					const { name, type, separator, valueMapping } = angularToReactMap[property];

					if (type === 'array') {
						reactSearchObj[name] = finetune[property].join(separator);
					} else if (type === 'bool') {
						reactSearchObj[name] = !!finetune[property];
					} else if (type === 'string') {
						if (finetune[property]) {
							if (valueMapping && valueMapping[finetune[property]]) {
								reactSearchObj[name] = valueMapping[finetune[property]];
							} else {
								reactSearchObj[name] = finetune[property];
							}
						}
					} else if (type === 'dateString') {
						if (finetune[property]) {
							reactSearchObj[name] = finetune[property].replaceAll('-', '/');
						}
					}
				}
			}
			return stringify(reactSearchObj);
		}
	}
}
